export enum EventType {
  DEEP_RESEARCH_STATUS = 'DEEP_RESEARCH_STATUS',
  SCHOLAR_SUMMARY_EVENT = 'SCHOLAR_SUMMARY_EVENT',
  PROJECT_SUMMARY_EVENT = 'PROJECT_SUMMARY_EVENT',
  BRANCH_SUMMARY_EVENT = 'BRANCH_SUMMARY_EVENT',
  NEW_ACTIVITY_EVENT = 'NEW_ACTIVITY_EVENT',
  DEEP_RESEARCH_PROCESS_STEP_EVENT = 'DEEP_RESEARCH_PROCESS_STEP_EVENT',
  VAULT_SUMMARY_EVENT = 'VAULT_SUMMARY_EVENT',
  DATA_MINING_PROCESS_EVENT = 'DATA_MINING_PROCESS_EVENT',
  DATA_MINING_PROCESS_RESULT_EVENT = 'DATA_MINING_PROCESS_RESULT_EVENT',
  VAULT_CHAT_SYNC_EVENT = 'VAULT_CHAT_SYNC_EVENT',
  SCHOLAR_DOCUMENT_PROCESSING_STATUS = 'SCHOLAR_DOCUMENT_PROCESSING_STATUS',
  VAULT_DOCUMENT_STATUS = 'VAULT_DOCUMENT_STATUS',
  PERMISSIONS_CHANGED = 'PERMISSIONS_CHANGED',
}
